<template>
	<v-menu
		v-model="menu"
		:open-on-focus="false"
		location="center center"
		submenu
		:close-on-content-click="false"
	>
		<template #activator="{ props }">
			<v-list-item
				v-bind="props"
				:title="`${t('component.theme.name')}: ${t(`component.theme.${theme.name.value}`)}`"
				:prepend-icon="t('component.theme.icon')"
				data-test="profile-menu__theme-list-item"
				append-icon="fas fa-chevron-right"
			></v-list-item>
		</template>
		<v-list
			:title="t('component.theme.name')"
			:selected="[theme.name.value]"
			:items="values"
			color="primary"
			@update:selected="changeTheme"
		>
		</v-list>
	</v-menu>
</template>
<script setup lang="ts">
import { useAppTheme } from '@/composables/appTheme'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from 'vuetify'

const menu = ref(false)

const { t } = useI18n()
const theme = useTheme()

const values = computed(() => [
	{
		title: t(`component.theme.name`),
		type: 'header',
		props: {
			twoLine: true,
			appendIcon: '$close',
			onClick: () => {
				menu.value = false
			},
		},
	},
	{
		type: 'divider',
	},
	...Object.keys(theme.themes.value).map((theme) => ({
		title: t(`component.theme.${theme}`),
		value: theme,
	})),
])

const { changeTheme } = useAppTheme()
</script>
<style></style>
